import { Typography } from '@mui/material';

import { TableCellCustom } from '@app/components/table';
import { IDepartment } from '../types';
import { RowActions } from './row-actions';

interface Props {
  row: IDepartment;
  selected: boolean;
  onSelectRow: VoidFunction;
  canAddDepartment: string;
}

const DepartmentRow = (props: Props) => {
  const { row, canAddDepartment } = props;

  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.name}</Typography>
      </TableCellCustom>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.desc || 'NA'}</Typography>
      </TableCellCustom>
      {canAddDepartment ? (
        <TableCellCustom width={50} align="center">
          <RowActions row={row} />
        </TableCellCustom>
      ) : undefined}
    </>
  );
};

export { DepartmentRow };
